// Zentrale Dienstgrad-Definitionen + Helmet-Mapping
// Genutzt von Dashboard (Helm-Hero, Schulterstücke) und Mitarbeiter-Seite.

// Kategorien: md = mittlerer Dienst, gd = gehobener Dienst, hd = höherer Dienst, ad = ärztlicher Dienst
export const DIENSTGRAD_CONFIG = {
  ANGESTELLT: { image: null, label: 'Angestellte/r – ohne Dienstgrad', category: 'angestellt', rank: -1 },
  // Mittlerer Dienst
  'BM-A1': { image: '/images/dienstgrade/bm-a1.svg', label: 'Brandmeisteranwärter (1. Jahr)', category: 'md', rank: 10 },
  'BM-A2': { image: '/images/dienstgrade/bm-a2.svg', label: 'Brandmeisteranwärter (2. Jahr)', category: 'md', rank: 11 },
  'BM-A':  { image: '/images/dienstgrade/bm-a2.svg', label: 'Brandmeisteranwärter',           category: 'md', rank: 11 },
  'BM':    { image: '/images/dienstgrade/bm.svg',    label: 'Brandmeister',                   category: 'md', rank: 20 },
  'OBM':   { image: '/images/dienstgrade/obm.svg',   label: 'Oberbrandmeister',               category: 'md', rank: 30 },
  'HBM':   { image: '/images/dienstgrade/hbm.svg',   label: 'Hauptbrandmeister',              category: 'md', rank: 40 },
  'HBMZ':  { image: '/images/dienstgrade/hbmz.svg',  label: 'Hauptbrandmeister m.Z.',         category: 'md', rank: 50 },

  // Gehobener Dienst
  'BOI-A1': { image: '/images/dienstgrade/boi-a1.svg', label: 'Brandoberinspektoranwärter (1. Jahr)', category: 'gd', rank: 60 },
  'BOI-A2': { image: '/images/dienstgrade/boi-a2.svg', label: 'Brandoberinspektoranwärter (2. Jahr)', category: 'gd', rank: 61 },
  'BI':     { image: '/images/dienstgrade/bi.svg',     label: 'Brandinspektor',          category: 'gd', rank: 70 },
  'BOI':    { image: '/images/dienstgrade/boi.svg',    label: 'Brandoberinspektor',      category: 'gd', rank: 80 },
  'BA':     { image: '/images/dienstgrade/ba.svg',     label: 'Brandamtmann',            category: 'gd', rank: 90 },
  'BAR':    { image: '/images/dienstgrade/bar.svg',    label: 'Brandamtsrat',            category: 'gd', rank: 100 },
  'BOAR':   { image: '/images/dienstgrade/boar.svg',   label: 'Brandoberamtsrat',        category: 'gd', rank: 110 },
  'BOARZ':  { image: '/images/dienstgrade/boarz.svg',  label: 'Brandoberamtsrat m.Z.',   category: 'gd', rank: 120 },

  // Höherer Dienst
  'BREF':   { image: '/images/dienstgrade/bref.svg',   label: 'Brandreferendar',         category: 'hd', rank: 130 },
  'BR':     { image: '/images/dienstgrade/br.svg',     label: 'Brandrat',                category: 'hd', rank: 140 },
  'BOR':    { image: '/images/dienstgrade/bor.svg',    label: 'Brandoberrat',            category: 'hd', rank: 150 },
  'BD':     { image: '/images/dienstgrade/bd.svg',     label: 'Branddirektor',           category: 'hd', rank: 160 },
  'LTDBD':  { image: '/images/dienstgrade/ltdbd.svg',  label: 'Leitender Branddirektor', category: 'hd', rank: 170 },
  'LBDV':   { image: '/images/dienstgrade/lbdv.svg',   label: 'Vertreter Landesbranddirektor', category: 'hd', rank: 180 },
  'LBD':    { image: '/images/dienstgrade/lbd.svg',    label: 'Landesbranddirektor',     category: 'hd', rank: 190 },

  // Ärztlicher Dienst
  'MEDR':       { image: '/images/dienstgrade/medr.svg',      label: 'Medizinalrat',                 category: 'ad', rank: 200 },
  'MEDOR':      { image: '/images/dienstgrade/medor.svg',     label: 'Medizinaloberrat',             category: 'ad', rank: 210 },
  'MEDDIR':     { image: '/images/dienstgrade/meddir.svg',    label: 'Medizinaldirektor',            category: 'ad', rank: 220 },
  'LTDMEDDIR':  { image: '/images/dienstgrade/ltdmeddir.svg', label: 'Leitender Medizinaldirektor',  category: 'ad', rank: 230 },
};

export const HELM_QUALIFIKATION_LABELS = {
  STANDARD: 'Standard – ohne Streifen',
  B3_BASIS: 'B3 Basis – ein Streifen',
  B3: 'B3 – zwei Streifen',
};

// B3-Qualifikationen werden ausdrücklich gesetzt, nicht aus HBM/HBMz abgeleitet.
// Die vorhandenen Bildschlüssel bleiben für eigene Wachenbilder erhalten.
export function getHelmetCategory(dienstgrad, helmQualifikation = null) {
  const cfg = DIENSTGRAD_CONFIG[(dienstgrad || '').toUpperCase()];
  if (cfg?.category === 'hd' || cfg?.category === 'ad') return 'gehob2';
  if (cfg?.category === 'gd') return 'gehob1';
  if (helmQualifikation === 'B3') return 'hbmz';
  if (helmQualifikation === 'B3_BASIS') return 'hbm';
  return 'standard';
}

// Default-Fallback-Bilder pro Kategorie
const DEFAULT_HELMETS = {
  standard: '/helme/helmstandard.webp',
  hbm:      '/helme/helmhbm.webp',
  hbmz:     '/helme/helmhbmz.webp',
  gehob1:   '/helme/helmgehob1.webp',
  gehob2:   '/helme/helmgehob2.webp',
};

// Helm-Bild pro Qualifikation; gehobener/höherer Dienst bleibt dienstgradabhängig.
// Optional ein `customConfig` Objekt mit eigenen URLs
// (z.B. {standard: '/helme/wachen/abc.webp', hbm: null, ...}). Fallback = Default.
export function getHelmetForDienstgrad(dienstgrad, customConfig = null, helmQualifikation = null) {
  const kategorie = getHelmetCategory(dienstgrad, helmQualifikation);
  const customUrl = customConfig?.[kategorie];
  return customUrl || DEFAULT_HELMETS[kategorie];
}

export { DEFAULT_HELMETS };

// Sortierung: Höhere Dienstgrade (gehoben/höher) zuerst, dann absteigend nach rank.
// Mitarbeiter ohne Dienstgrad ganz unten. Innerhalb gleichen Rangs alphabetisch nach Nachname.
export function compareByDienstgrad(a, b) {
  const ca = DIENSTGRAD_CONFIG[(a.dienstgrad || '').toUpperCase()];
  const cb = DIENSTGRAD_CONFIG[(b.dienstgrad || '').toUpperCase()];
  const ra = ca ? ca.rank : -1;
  const rb = cb ? cb.rank : -1;
  if (ra !== rb) return rb - ra; // höhere Rank-Werte zuerst
  return (a.nachname || '').localeCompare(b.nachname || '', 'de');
}
